var $1f7e1cf2285af2b2$exports = {};
$1f7e1cf2285af2b2$exports = {
  "Clear search": "Aramay\u0131 temizle"
};
export { $1f7e1cf2285af2b2$exports as default };